"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SokoBidCopyOverlay = exports.getStatusText = void 0;
exports.getLabel = getLabel;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var FolderTree_1 = require("components/FolderTree");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var BidActions = require("@caddigital/sok-reducers/lib/actions/bid");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/files");
var Types = require("types");
var extractReturnType = Types.extractReturnType;
var mapStateToProps = function (state) { return ({
    projectCopy: state.bid.projectCopy
}); };
var mapDispatchToProps = function (dispatch) { return ({
    changeExpand: function (expand, folder) {
        return dispatch(BidActions.FolderTreeActions.copyChangeExpand(expand, folder));
    },
    selectItem: function (folder, value) {
        dispatch(BidActions.FolderTreeActions.selectFile(folder, value));
    },
    getContent: function (parent) {
        return dispatch(BidActions.FolderTreeActions.fetchTree(parent, []));
    },
    closeOverlay: function (bid) {
        dispatch(FilesActions.refreshFiles());
        dispatch(BidActions.FolderTreeActions.copyFilesReset());
        dispatch(BidActions.FolderTreeActions.copyFilesToggleOverlay(Types.Reducer.CLOSED));
    },
    copyFiles: function (files, ignored, destination) {
        dispatch(BidActions.FolderTreeActions.copyFilesRequestAction('COPY', files, destination, ignored));
    },
    userToggleCopyOrMoveResult: function () {
        dispatch(BidActions.FolderTreeActions.userToggleCopyOrMoveResult());
    }
}); };
var statePropsExtractable = extractReturnType(mapStateToProps);
var dispatchPropsExtractable = extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('SokoBidCopyFromProject'), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (this.props.projectCopy.mode === 'CLOSED' &&
            nextProps.projectCopy.mode !== 'CLOSED') {
            nextProps.getContent({
                id: nextProps.currentProject.rootFolder,
                project: nextProps.currentProject.id
            });
        }
    }
}), recompose_1.pure);
function traverseSelected(node, selected, picked, ignored, parent) {
    if (selected === void 0) { selected = []; }
    if ((!parent || !parent.getSelected()) && node.getSelected() === true) {
        picked[node.getValue().id] = node;
        selected.push(node);
    }
    node.getChildren().reduce(function (prev, c) {
        var value = c.getValue();
        var p = c.getParentNode();
        if (!p || (prev[p.getValue().id] && c.getSelected() === true)) {
            // return prev
        }
        else if (ignored && c.getSelected() === false) {
            ignored[value.id] = c;
        }
        else {
            if (c.getSelected() === true) {
                prev[value.id] = c;
            }
        }
        traverseSelected(c, selected, prev, ignored, p);
        return prev;
    }, picked);
    return selected;
}
function getLabel(mode) {
    return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/titleCopy');
}
var getStatusText = function (mode, success, failure) {
    if ((mode === 'COPY_FROM_SELECTION_CART' || mode === 'COPY') &&
        success &&
        !failure) {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusCopied');
    }
    else if ((mode === 'MOVE_FROM_SELECTION_CART' || mode === 'MOVE') &&
        success &&
        !failure) {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusMoved');
    }
    else if ((mode === 'MOVE_FROM_SELECTION_CART' || mode === 'MOVE') &&
        !success) {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusMove');
    }
    else {
        return (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusCopy');
    }
};
exports.getStatusText = getStatusText;
exports.SokoBidCopyOverlay = enhance(function (props) { return (React.createElement(sok_ui_1.Overlay, { isOpen: props.projectCopy.mode !== Types.Reducer.CLOSED, onClose: function () { return props.closeOverlay(props.currentFolder); } },
    React.createElement(sok_ui_1.SideMenu, { className: 'sok-file-move-details', isOpen: props.projectCopy.mode !== Types.Reducer.CLOSED, docked: false, orientation: 'right' },
        React.createElement(sok_ui_1.Header, { onClose: function () { return props.closeOverlay(props.currentFolder); } }, (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/statusCopy')),
        React.createElement(sok_ui_1.Container, { className: props.projectCopy.status !== 'STANDBY' ||
                (props.projectCopy.data.status === 'FETCHING' &&
                    !props.projectCopy.data.root)
                ? 'centered'
                : null },
            props.projectCopy.data.status === 'FETCHING' &&
                !props.projectCopy.data.root && (React.createElement("div", { className: 'loading-spinner' },
                React.createElement(sok_ui_1.LoadingSpinner, null),
                React.createElement("div", { className: "loadingText" }, (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/fetchingContent')))),
            props.projectCopy.status !== 'STANDBY' && (React.createElement("div", { className: "loading-spinner" },
                React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.projectCopy.status === 'COPYING', success: props.projectCopy.status === 'SUCCESS' }))),
            (props.projectCopy.status === 'SUCCESS' ||
                props.projectCopy.status === 'FAILURE') && (React.createElement("div", { className: 'result-information' },
                React.createElement("div", { className: 'result-text' },
                    (0, exports.getStatusText)(props.projectCopy.mode, props.projectCopy.status === 'SUCCESS', props.projectCopy.status === 'FAILURE'),
                    ' ',
                    props.projectCopy.data.tree &&
                        props.projectCopy.data.tree
                            .getNodes()
                            .filter(function (f) { return f.getSelected(); }).length,
                    ' ',
                    (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/itemsTo'),
                    ' ',
                    props.currentFolder ? props.currentFolder.name : ''),
                React.createElement(sok_ui_1.Button, { style: { marginRight: '20px' }, color: props.projectCopy.status === 'SUCCESS' ? 'base-green' : 'red', className: 'ok-button', onClick: function () {
                        if (props.projectCopy.status === 'SUCCESS') {
                            return props.closeOverlay(props.currentFolder);
                        }
                        if (props.currentProject && props.currentFolder) {
                            props.getContent({
                                id: props.currentProject.rootFolder,
                                project: props.currentProject.id
                            });
                            props.userToggleCopyOrMoveResult();
                        }
                    }, text: props.projectCopy.status === 'SUCCESS'
                        ? "".concat((0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/submitOk'))
                        : "".concat((0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/submitFailed')) }))),
            props.projectCopy.data.tree !== null &&
                props.projectCopy.status === 'STANDBY' &&
                props.currentProject && (React.createElement(FolderTree_1.default, { parentIdentifier: props.currentProject.rootFolderIdentifier, tree: props.projectCopy.data.tree, selectItem: props.selectItem, changeExpand: props.changeExpand, getContent: props.getContent, expandType: FolderTree_1.ANY_CONTENT }))),
        React.createElement(sok_ui_1.Footer, null,
            props.projectCopy.status === 'STANDBY' ||
                props.projectCopy.status === 'FAILURE' ? (React.createElement(sok_ui_1.Button, { color: 'base-green', disabled: props.projectCopy.data.status !== 'FETCHED' ||
                    !(props.projectCopy.data.tree &&
                        !!props.projectCopy.data.tree
                            .getNodes()
                            .find(function (f) { return f.getSelected() === true; })), onClick: function () {
                    if (props.projectCopy.data.tree) {
                        var picked = {};
                        var ignored = {};
                        var selected = traverseSelected(props.projectCopy.data.tree.getRoot(), [], picked, ignored);
                        props.copyFiles(Object.values(picked), Object.values(ignored), props.currentFolder);
                    }
                }, text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/save') })) : (React.createElement(sok_ui_1.Button, { color: 'blue', onClick: function () {
                    if (props.currentProject) {
                        props.userToggleCopyOrMoveResult();
                    }
                }, disabled: props.projectCopy.status === 'COPYING', text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/continue') })),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', onClick: function () { return props.closeOverlay(props.currentFolder); }, disabled: props.projectCopy.status === 'COPYING', text: (0, translation_1.getLocalization)('userfront/project/FileMoveOverlay/cancel') }))))); });
